import React from "react";
import { Link } from "gatsby";
import "components/Project-detail-shared/project-detail-shared.scss";
import "./project-hero.scss";
import ProjectStats from "components/Project-stats/project-stats";

const formatProjectType = (types) => {
  const arr = Array.isArray(types) ? types : [types].filter(Boolean);
  return arr
    .filter(Boolean)
    .map((t) => t.replace(/[-_]+/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()))
    .join(" / ");
};

const ProjectHero = ({ projectHeroData, caseStudyData }) => {
  const technologies = projectHeroData?.technologiesData?.nodes || [];
  const featureImage =
    caseStudyData?.heroImage ||
    projectHeroData?.featureImage2xDisplays?.sourceUrl ||
    projectHeroData?.featureImage?.guid;
  const projectType = formatProjectType(projectHeroData?.projectType);

  const fallbackTitle = "Automating Regulatory Compliance for Aimantis PMS";
  const projectName = caseStudyData?.caseStudyTitle || projectHeroData?.projectName || fallbackTitle;
  
  // Use dynamic hero description if available, otherwise fallback
  const shortDescription = caseStudyData?.heroDescription || projectHeroData?.shortDescription || "";

  return (
    <section className="pd-hero pd-hero-split">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-12 col-lg-6">
            <Link to="/case-studies" className="pd-hero-back">
              <i className="fas fa-arrow-left"></i> Case Studies
            </Link>

            <div className="pd-hero-content wow fadeInUp">

              <h1 className="pd-hero-title">
                {/* We parse for "Web" to highlight it for the dummy case, but dynamically it'll just be the string */}
                {projectName.includes("Aimantis") || projectName.includes("Alloggiati") ? (
                  <>Alloggiati <span className="color-font">Web</span> Integration</>
                ) : (
                  projectName
                )}
              </h1>

              <p className="pd-hero-desc">{shortDescription}</p>

              {/* Render stats inside hero (only when data exists) */}
              {caseStudyData?.keyStats?.length > 0 && (
                <div className="pd-hero-stats-wrapper">
                  <ProjectStats stats={caseStudyData.keyStats} />
                </div>
              )}
            </div>
          </div>
          <div className="col-12 col-lg-6">
            {featureImage && (
              <div className="pd-hero-image-wrapper wow fadeInRight">
                <img src={featureImage} alt={projectName} className="img-fluid pd-hero-image" />
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectHero;
